import { FC, CSSProperties, ReactNode } from "react";

const Float: FC<{ children: ReactNode; duration?: number; delay?: number; distance?: number }> = ({ children, duration = 5, delay = 0, distance = -8 }) => {
  return (
    <div
      className="landing-hero-float"
      style={{ "--float-duration": `${duration}s`, "--float-delay": `${delay}s`, "--float-distance": `${distance}px` } as CSSProperties}
    >
      {children}
    </div>
  );
};

export default Float;